module.exports = __webpack_public_path__ + "static/media/pickup-dropoff-line@3x.617d3947.webp";